export default __webpack_public_path__ + "static/media/calendar-icon.8a102946.svg";